<template>
	<div>
		<!-- Header  -->
		<div class="unit-title">
			<h3 class="font-weight-regular mb-0 white--text">
				What departments, initiatives and organisations are in the Etisalat
				eco-system?
			</h3>
			<p>Click the + to add a department</p>
			<v-btn @click="add" class="ma-1 white" fab small light>
				<v-icon>mdi-plus</v-icon></v-btn
			>
		</div>
		<v-btn @click="toggleCompact" class="ma-1 black white--text" light>{{
			compactText
		}}</v-btn>
		<!-- Content  -->
		<v-row>
			<v-col cols="6">
				<div class="unit-items blue-grey darken-4">
					<div class="unit-title mb-3">
						<h4 class="font-weight-regular mb-0 white--text lh-0">
							Same Logo<br />Same Look &amp; Feel
						</h4>
					</div>
					<brand-architecture-card
						v-for="(item, index) in col1"
						:key="`col1-${index}`"
						:item="item"
						@edit="edit"
						@remove="remove"
						@show="show"
						:index="item.index"
						:thumbnail="true"
						:mode="mode"
					/>
				</div>
			</v-col>
			<v-col cols="6">
				<div class="unit-items blue-grey darken-3">
					<div class="unit-title mb-3">
						<h4 class="font-weight-regular mb-0 white--text lh-0">
							Same Logo<br />Different Look &amp; Feel
						</h4>
					</div>
					<brand-architecture-card
						v-for="(item, index) in col2"
						:key="`col2-${index}`"
						:item="item"
						@edit="edit"
						@show="show"
						@remove="remove"
						:index="item.index"
						:thumbnail="true"
						:mode="mode"
					/>
				</div>
			</v-col>
			<v-col cols="6">
				<div class="unit-items blue-grey darken-2">
					<div class="unit-title mb-3">
						<h4 class="font-weight-regular mb-0 white--text lh-0">
							Different Logo<br />Same Look &amp; Feel
						</h4>
					</div>
					<brand-architecture-card
						v-for="(item, index) in col3"
						:key="`col3-${index}`"
						:item="item"
						@edit="edit"
						@show="show"
						@remove="remove"
						:index="item.index"
						:thumbnail="true"
						:mode="mode"
					/>
				</div>
			</v-col>
			<v-col cols="6">
				<div class="unit-items blue-grey darken-1">
					<div class="unit-title mb-3">
						<h4 class="font-weight-regular mb-0 white--text lh-0">
							Different Logo<br />Different Look &amp; Feel
						</h4>
					</div>
					<brand-architecture-card
						v-for="(item, index) in col4"
						:key="`col4-${index}`"
						:item="item"
						@edit="edit"
						@remove="remove"
						@show="show"
						:index="item.index"
						:thumbnail="true"
						:mode="mode"
					/></div
			></v-col>
		</v-row>
		<!-- Dialog -->
		<v-dialog v-model="dialog" max-width="800">
			<v-card v-if="dialogMode === 'delete'" light>
				<v-card-title>
					Are you sure you want to delete this item?
				</v-card-title>
				<v-card-text class="">
					<v-btn light color="amber mr-5" class="" @click="removeItem"
						>Delete</v-btn
					>
					<v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
				</v-card-text>
			</v-card>
			<v-card light v-else-if="dialogMode === 'edit'">
				<brand-architecture-form v-model="item" title="Edit an item">
					<v-btn light color="green" class="mt-10 mr-2" @click="editItem"
						>Update</v-btn
					>
					<v-btn light color="white" class="mt-10 mr-2" @click="cancel"
						>Cancel</v-btn
					>
				</brand-architecture-form>
			</v-card>
			<v-card light v-else-if="dialogMode === 'show'">
				<brand-architecture-card :item="item" :controls="false" mode="full" />

				<v-btn light color="white" class="mt-10 mr-2" @click="cancel"
					>Close</v-btn
				>
			</v-card>
			<v-card light v-else>
				<v-card-text class="">
					<brand-architecture-form v-model="item" title="Add an item">
						<v-btn light color="green" class="mt-10 mt-2 mr-2" @click="addItem"
							>Create Attribute</v-btn
						>
						<v-btn light color="white" class="mt-10 mt-2 mr-2" @click="cancel"
							>Cancel</v-btn
						>
					</brand-architecture-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import ArchitectureMixin from './ArchitectureMixin';
import BrandArchitectureForm from './BrandArchitectureForm';
import BrandArchitectureCard from './BrandArchitectureCard';

export default {
	name: 'BrandArchitectureStep2',
	mixins: [ArchitectureMixin],
	data() {
		return {
			items: this.value,
			compact: false,
		};
	},
	props: {
		value: Array,
	},
	watch: {
		value: {
			handler: function(val) {
				this.items = val;
			},
			deep: true,
		},
	},
	components: {
		BrandArchitectureForm,
		BrandArchitectureCard,
	},
	computed: {
		mode() {
			return this.compact ? 'compact' : 'thumbnail';
		},
		compactText() {
			return this.compact ? 'Expand' : 'Compact';
		},
		col1() {
			return this.items ? this.items.filter((x) => x.logo && x.look) : [];
		},
		col2() {
			return this.items ? this.items.filter((x) => x.logo && !x.look) : [];
		},
		col3() {
			return this.items ? this.items.filter((x) => !x.logo && x.look) : [];
		},
		col4() {
			return this.items ? this.items.filter((x) => !x.logo && !x.look) : [];
		},
	},
	methods: {
		toggleCompact() {
			this.compact = !this.compact;
		},
	},
};
</script>

<style lang="scss" scoped>
.unit-items {
	min-height: 40vh;
	padding: 0.5rem 1rem;
	.unit-title {
		margin-bottom: 0.5rem;
	}
}
.unit-title {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}
</style>
